exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".flexinTwo {\n  font-family: sans-serif;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n\n}\n.electricBoogaloo {\n  -webkit-box-flex: 0;\n      -ms-flex: none | [ <'flex-grow'> <'flex-shrink'>? || <'flex-basis'> ];\n          flex: none | [ <'flex-grow'> <'flex-shrink'>? || <'flex-basis'> ];\n  text-align: center;\n}\n.showDetails {\n  border-color: white;\n  background-color: white;\n  border-radius: 40px;\n  border-width: 0px;\n}\n\n#displayMessage {\n  text-align: center;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/functional_components/product-detail/product-detail.component.css
// module id = 371
// module chunks = 1